import {
  DeprecatedSuccessAlert,
  ErrorAlert
} from "@shared/ui.legacy-components";
import React, { useEffect } from "react";

import { useProfileNotificationsContext } from "./context";
import { wrapper } from "./styles.css";

export function ProfileNotification(): JSX.Element {
  const { notification, closeNotification } = useProfileNotificationsContext();

  useEffect(() => {
    if (notification) {
      window.scrollTo(0, 0);
    }
  }, [notification]);

  if (notification === null) {
    return <></>;
  }

  return (
    <div className={wrapper}>
      {notification && notification.type === "error" && (
        <div>
          <ErrorAlert
            primaryMessage={notification.header}
            secondaryMessage={notification.message}
            close={() => {
              closeNotification();
            }}
          />
        </div>
      )}
      {notification && notification.type === "success" && (
        <div>
          <DeprecatedSuccessAlert
            primaryMessage={notification.header}
            secondaryMessage={notification.message}
            close={() => {
              closeNotification();
            }}
          />
        </div>
      )}
    </div>
  );
}
